var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Ope-Dash-Operacional"},[_c('PageTitle',{attrs:{"icon":"fa fa-bar-chart","main":"Dashboard Operacional","sub":"Indicadores"}}),_c('div',{staticClass:"Ope-Dash-Operacional"},[_vm._v("\nDashboard\n\n\n\n        ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }